import { Box } from '@mui/material';
import React from 'react';

interface MiniatureBlockPreviewProps {
  children: React.ReactNode;
}

/**
 * Non-interactive framed thumbnail for a palette block's preview graphic.
 * Pointer events are disabled so the miniature never captures clicks/hovers —
 * the whole palette card stays a single draggable surface.
 */
export default function MiniatureBlockPreview({ children }: MiniatureBlockPreviewProps) {
  return (
    <Box
      aria-hidden
      sx={{
        overflow: 'hidden',
        borderRadius: 1,
        bgcolor: '#fff',
        border: '1px solid #ececec',
        p: 1,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      {children}
    </Box>
  );
}
